<template>
	<div>
		<div class="progress-bar">
			<div :class="'fill-' + index" :style="{width: percentage + '%'}" class="progress-bar-fill" />
			<h3 class="percentage">{{ percentage }}%</h3>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'result-progress-bar',
		props: {
			index: {
				type: Number,
				required: true
			},
			percentage: {
				type: Number,
			}
		}
	}
</script>

<style lang="less" scoped>
	@import "~@less/variables.less";

	.percentage {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		color: #222222;
	}

	.progress-bar {
		position: relative;
		width: 100%;
		height: 40px;
		background-color: white;
		border: solid #222222 2px;
	}

	.progress-bar-fill {
		height: 100%;
		background-color: @grey-light;
		// min-width: 10px;
	}

	// .fill-0 {
	// 	background: @choice-color-1;
	// }

	// .fill-1 {
	// 	background: @choice-color-2;
	// }

	// .fill-2 {
	// 	background: @choice-color-3;
	// }

	// .fill-3 {
	// 	background: @choice-color-4;
	// }

	// .fill-4 {
	// 	background: @choice-color-5;
	// }

	// .fill-5 {
	// 	background: @choice-color-6;
	// }
</style>